import { useApi, useToast, useWorkspace } from '~/contexts';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PageLoader } from '~/routes/public/pages';

const RETURN_TO = '/my-profile/calendar';

function MicrosoftCalendarRedirect() {
  const api = useApi();
  const location = useLocation();
  const { navigateWorkspace } = useWorkspace();
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      let data;
      try {
        ({ data } = await api.microsoftCalendar.authorize({ uri: window.location.href }));
      } catch (error) {
        const failure = error?.response?.data ?? {};
        const message = error?.message || 'We could not connect your Outlook calendar. Please try again.';

        if (failure.workspaceKey) {
          toast.error(message);
          await navigateWorkspace(failure.workspaceKey, RETURN_TO);
          return;
        }

        if (error?.status === 401 || error?.status === 403) toast.error('Please sign in and try again.');
        else toast.error(message);
        history.push('/');
        return;
      }

      if (data.connected) toast.success('Your Outlook calendar is connected.');
      await navigateWorkspace(data.workspaceKey, RETURN_TO);
    })();
  }, [location.search, api, navigateWorkspace, toast, history]);

  return <PageLoader />;
}

export default MicrosoftCalendarRedirect;
